"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const Flex_1 = tslib_1.__importDefault(require("./Elements/Flex"));
const Container = (0, styled_components_1.default)(Flex_1.default) `
  margin-right: auto;
  margin-left: auto;
  width: ${props => (props.fluid ? '100%' : '1640px')};

  @media screen and (max-width: 1840px) {
    width: 100%;
    padding-left: 140px;
    padding-right: 140px;
  }

  @media screen and (max-width: 1440px) {
    max-width: ${props => (props.fluid ? '100%' : '1440px')};
  }
  @media screen and (max-width: 1200px) {
    padding-left: 48px;
    padding-right: 48px;
    max-width: ${props => (props.fluid ? '100%' : '928px')};
  }
  @media screen and (max-width: 960px) {
    width: 100%;
    padding-left: 24px;
    padding-right: 24px;
    max-width: ${props => (props.fluid ? '100%' : '768px')};
  }
  @media screen and (max-width: 480px) {
    padding-left: 12px;
    padding-right: 12px;
    max-width: ${props => (props.fluid ? '100%' : '350px')};
  }
`;
exports.default = Container;
